import { render, staticRenderFns } from "./UserTemplate.vue?vue&type=template&id=6e8d180d&scoped=true"
import script from "./UserTemplate.vue?vue&type=script&lang=js"
export * from "./UserTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d180d",
  null
  
)

export default component.exports